import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AMCForm } from '../../components/AMCForm';
import { useDeleteAMCMutation, useGetAMCQuery, useUpdateAMCMutation } from '../../services/api';

export default function AMCDetailsTab() {
  const { id = '' } = useParams<{ id: string }>();
  const { data: amc, isLoading } = useGetAMCQuery(id);
  const [updateAMC] = useUpdateAMCMutation();
  const [deleteAMC] = useDeleteAMCMutation();
  const navigate = useNavigate();

  const handleUpdateAMC = async (values: typeof amc, logo?: string) => {
    console.log(values);
    await updateAMC({
      ...values,
      ...(logo && { logo }),
      id,
    }).unwrap();
  };

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  return amc ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: 600, mx: 'auto' }}>
      <AMCForm
        initialValues={amc}
        onSubmit={handleUpdateAMC as any}
        submitButtonText="Update AMC"
      />
      <Button
        color="error"
        onClick={() => {
          deleteAMC(id);
          navigate(-1);
        }}
      >
        Delete AMC
      </Button>
    </Box>
  ) : null;
}
